import React, { FC, ReactElement, useContext } from 'react';
import { LiveMatchContext } from '../context';
import { IFootballMatchEvent } from '../interfaces/interfaces';
import { trans } from '../helpers/helperFunctions';

type WidgetPlayersProps = {
  sportType: string;
};

interface Action extends IFootballMatchEvent {
  isHome: boolean;
  isAway: boolean;
}

const goalTypesToDisplay = ['goal', 'own goal', 'powerplay goal'];

const WidgetPlayers: FC<WidgetPlayersProps> = ({
  sportType
}: WidgetPlayersProps): ReactElement | null => {
  const {
    liveMatchData: { home, away, details }
  } = useContext(LiveMatchContext);

  const actions = details?.matchEvent.filter((action) =>
    goalTypesToDisplay.includes(action.matchAction)
  );

  const mapActions: Action[] = actions?.map((action) => ({
    ...action,
    isHome: action.teamId === home.contestantId,
    isAway: action.teamId === away.contestantId
  }));

  const goalScorersExist = mapActions?.find((action) =>
    goalTypesToDisplay.includes(action.matchAction)
  );

  return !goalScorersExist ? null : (
    <div className={`widget-players widget-players-${sportType}`}>
      {mapActions?.map((item, i) => {
        let ownGoal;
        if (item.matchAction === 'own goal') {
          ownGoal = true;
        }
        // If own goal, render player to the opposing side
        const renderPlayerToLeft = ownGoal ? !item.isHome : !!item.isHome;
        const renderPlayerToRight = ownGoal ? !item.isAway : !!item.isAway;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`${i}${Math.random()}`} className="widget-players-row">
            <div className="widget-players-home">
              {renderPlayerToLeft
                ? `${item.person?.contestantName || 'Unknown'}${
                    ownGoal ? ` ${trans('own-goal')}` : ''
                  }`
                : ''}
            </div>
            <div className="widget-players-time">{item.minute}’</div>
            <div className="widget-players-away">
              {renderPlayerToRight
                ? `${item.person?.contestantName || 'Unknown'}${
                    ownGoal ? ` ${trans('own-goal')}` : ''
                  }`
                : ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WidgetPlayers;
